<template>
    <div name="info" class="info-area"> 
        <span class="subject-text">{{ promotion_data.subject[0]}}</span>
        <span class="name-text">{{ promotion_data.profile.partner_name }}</span>
        <div class="row-tag">
            <span class="tag" v-if="hasContact">방문진료</span>
            <span class="tag" v-if="hasContactless">비대면진료</span>
        </div>

        <div class="info-box">
            <div class="row">
                <div class="schedule-today">
                    <img style="width: 22px;" src="../../assets/calendar.png" />
                    <span v-if="todaySchedule && todaySchedule.is_open" class="status-badge open">진료중</span>
                    <span v-else class="status-badge closed">진료종료</span>
                    <span class="day-time">
                        {{ todayDayName }} | {{ todayTimeRange }}
                    </span>
                </div>
            </div>
            <div class="row">
                <img style="width: 22px;" src="../../assets/location_icn.png" />
                <span class="info-text" style="margin-left: 8px;">{{ promotion_data.profile.address }}</span>
            </div>
            <div class="row">
                <img style="width: 22px;" src="../../assets/call_icn.png" />
                <span class="phone-text" @click="call">{{ promotion_data.profile.representative_number }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'info',
    props: ['promotion_data', 'hasContact', 'hasContactless', 'schedules'],
    data() {
        return {
            dayNames: ['일', '월', '화', '수', '목', '금', '토']
        }
    },
    computed: {
        todayDayOfWeek() {
            return new Date().getDay()
        },
        todaySchedule() {
            if (!this.schedules || this.schedules.length === 0) return null
            return this.schedules.find(s => s.day_of_week === this.todayDayOfWeek)
        },
        todayDayName() {
            return this.dayNames[this.todayDayOfWeek]
        },
        todayTimeRange() {
            if (!this.todaySchedule || !this.todaySchedule.is_open) return '휴진'
            const times = this.todaySchedule.base_hospital_schedule_time
            if (!times || times.length === 0) return '시간 정보 없음'
            const startTimes = times.map(t => t.start_time).sort()
            const endTimes = times.map(t => t.end_time).sort()
            return `${startTimes[0]} ~ ${endTimes[endTimes.length - 1]}`
        }
    },
    methods: {
        convertSchedule: function(schedule)
        {
            if(schedule.length === 0)
            {
                return '-'
            }
            // 오늘 날짜 객체
            const today = new Date();
            // 요일 번호 (0: 일요일 ~ 6: 토요일)
            const dayNumber = today.getDay();
            return schedule[dayNumber].is_open ? `${this.convertDayNumberToStr(dayNumber)} | ${schedule[dayNumber].base_hospital_schedule_time[0].start_time} ~ ${schedule[dayNumber].base_hospital_schedule_time[schedule[dayNumber].base_hospital_schedule_time.length - 1].end_time}` : '-';
        },
        isOpen: function(schedule)
        {
            if(schedule.length === 0)
            {
                return '진료준비중'
            }
            // 오늘 날짜 객체
            const today = new Date();
            // 요일 번호 (0: 일요일 ~ 6: 토요일)
            const dayNumber = today.getDay();
            return schedule[dayNumber].is_open ? '비대면 진료가능' : '휴무';
        },
        convertDayNumberToStr: function(number)
        {
            return number === 0 ? '일' : number === 1 ? '월' : number === 2 ? '화' : number === 3 ? '수' : number === 4 ? '목' : number === 5 ? '금' : number === 6 ? '토' : '';
        },
        call: function()
        {
            this.$emit('call')
        }
    }
}
</script>

<style scoped>
    .info-area {
        width: 100%;
        padding: 20px 0px 0px 0px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    .info-box {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border-radius: 6px;
        background: var(--gray-00, #FFF);
        box-shadow: 0 0 10px 0 rgba(0, 33, 56, 0.09);
        margin-top: 32px;
    }
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .isopen-text {
        color: var(--Primary-100, #008DEF);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        width: 100px;
        margin-left: 8px;
    }
    .info-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        margin-left: 4px;
    }
    .phone-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        margin-left: 9px;
    }
    .subject-text {
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }
    .name-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 120% */
        margin-top: 4px;
    }
    .row-tag {
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
        gap: 8px;
        margin-top: 16px;
    }
    .tag {
        border-radius: 3px;
        background: var(--gray-20, #F3F5F8);
        height: 26px;
        box-sizing: border-box;
        padding: 0 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 133.333% */
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .schedule-today {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .status-badge {
        border-radius: 4px;

        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }
    .status-badge.open {

        color: var(--Primary-100, #008DEF);
    }
    .status-badge.closed {
        color: #999;
    }
    .day-time {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }
</style>


// WEBPACK FOOTER //
// src/components/hospital/Info.vue